window.deliveryDecide = function(country, above_19_hide = false) {
  const recipient_info   = document.querySelector("#recipient_info");
  const delivery_country = document.querySelector("#delivery_country");
  const above_19         = document.querySelector("#above_19");
  const plan_options     = document.querySelectorAll(`.above_19_button`);

  if(delivery_country) delivery_country.style.display = "none";
  if(!above_19_hide && above_19) above_19.style.display = "block";

  if(country === "canada") {
    if(recipient_info) recipient_info.style.display = "none";
  }else {
    if(recipient_info) recipient_info.style.display = "block";

    const recipient_name           = document.querySelector(`input[name="recipient_name"]`);
    const recipient_phone_number   = document.querySelector(`input[name="recipient_phone_number"]`);
    const chinese_address          = document.querySelector(`input[name="chinese_address"]`);
    const recipient_province       = document.querySelector(`select[name="recipient_province"]`);
    const recipient_postal_code    = document.querySelector(`input[name="recipient_postal_code"]`);
    const recipient_msg_type       = document.querySelector(`select[name="recipient_msg_type"]`);
    const recipient_msg_id         = document.querySelector(`input[name="recipient_msg_id"]`);
    const sim_pickup_method        = document.querySelector(`#sim_pickup_method`);
    const sim_pickup_method_select = document.querySelector(`select[name="sim_pickup_method"]`);
    const recipient_country        = document.querySelector(`select[name="recipient_country"]`);

    if(recipient_name) recipient_name.required = true;
    if(recipient_phone_number) recipient_phone_number.required = true;
    if(chinese_address) chinese_address.required = true;
    if(recipient_province) recipient_province.required = true;
    if(recipient_country) recipient_country.required = true;
    if(recipient_postal_code) recipient_postal_code.required = true;
    if(recipient_msg_type) recipient_msg_type.required = true;
    if(recipient_msg_id) recipient_msg_id.required = true;
    if(sim_pickup_method_select) {
      const option = document.createElement("option");

      option.value = "delivery_in_home_country"
      sim_pickup_method_select.appendChild(option);
      option.selected = true;

      if(sim_pickup_method) sim_pickup_method.style.display = "none";
    }
    if(plan_options && plan_options.length > 2) plan_options[2].style.display = "none";
  }
};

window.pickupStoreDisplay = function(e) {
  const pickup_store    = document.querySelector("#pickup_store");
  const pickup_store_id = document.querySelector(`select[name="pickup_store_id"]`)

  if(e.value === "sim_pick_up_in_store") {
    if(pickup_store_id) pickup_store_id.required = true;
    if(pickup_store) pickup_store.style.display = "";
  }else {
    if(pickup_store_id) {
      pickup_store_id.required = false;
      pickup_store_id.value    = "";
    }
    if(pickup_store) pickup_store.style.display = "none";
  }
};

module.exports = {
  deliveryDecide: window.deliveryDecide,
  pickupStoreDisplay: window.pickupStoreDisplay
};